export function getNumberWithComa(value?: string | number) {
  if (!value) {
    return;
  }

  return Number(value.toString().replace(',', '')).toLocaleString();
}
